export const TRAINER_TITLES = [
  { value: 1, label: "inż." },
  { value: 2, label: "mgr" },
  { value: 3, label: "mgr inż." },
  { value: 4, label: "prof." },
  { value: 5, label: "dr" },
  { value: 6, label: "dr hab." },
  { value: 7, label: "lek. wet." },
];
